module.exports = __webpack_public_path__ + "static/img/3-3.70d2199e.png";